import React, {PureComponent} from "react"
import {Row, Col} from "react-bootstrap"
import styled from "styled-components"

import {label3} from "@irati/ui/src/Labels/css/labels"
import padding from "@irati/ui/src/global/padding"
import {FormattedMessage} from "@irati/utils/lang"

import Empty from "./EmptyRewards"
import MyRewardsItem from "./MyRewardsItem"

const ColHeader = styled.div`
  ${label3}
  padding-bottom: ${padding.tiny};
`

interface Props {
  openPopUp(redemption: RewardRedemption): void,
  redemptions: RewardRedemption[]
}

class MyRewardsList extends PureComponent<Props> {
  render() {
    const {redemptions, openPopUp} = this.props

    if (redemptions.length === 0) {
      return (
        <Row>
          <Empty />
        </Row>
      )
    }

    return (
      <>
        <Row>
          <Col xsHidden sm={7} />
          <Col xsHidden sm={3}>
            <ColHeader>
              <FormattedMessage id="recognition.account.rewards.receivedHeader" />
            </ColHeader>
          </Col>
          <Col xsHidden sm={2}>
            <ColHeader>
              <FormattedMessage id="recognition.account.rewards.actionHeader" />
            </ColHeader>
          </Col>
        </Row>
        {
          redemptions.map((redemption: RewardRedemption) =>
            <MyRewardsItem
              openPopUp={openPopUp}
              key={redemption.id}
              redemption={redemption} />
          )
        }
      </>
    )
  }
}

export default MyRewardsList
